import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GlobalsService} from '@shared/services/globals.service';

@Component({
  selector: 'app-adminview',
  templateUrl: './adminview.component.html',
  styleUrls: ['./adminview.component.scss']
})
export class AdminviewComponent implements OnInit {

  isExpanded: boolean;

  constructor(protected http: HttpClient, private globalsservice: GlobalsService) {
    this.isExpanded = false;
  }

  ngOnInit(): void {

  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  /**
   * TODO
   * Used for first AOS imports, keep it until fully deployed and tested on prod. Endpoint is deactivated by default anyway.
   */
  async syncUserCompany() {
    const url = this.globalsservice.getBffapiroot() + '/v1/admin/syncUserCompany';
    const { results } = await this.http.get<any>(url).toPromise();
    console.log(results);
  }

}
